import CodeMirror from "codemirror";
// TODO: load dynamically
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/mode/css/css";
import { forwardRef, useContext, useEffect, useRef, useState } from "react";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/darcula.css";
import { useAttribute } from "lib/hooks";
import sampleCode from "./sampleCode";
import { rootNamespace } from "config";
import { TreeContext } from "pages/Editor";

export const CodeEditor = forwardRef(function CodeEditor(
  { value = "", mode = "javascript", readOnly = false },
  editor
) {
  const ref = useRef();
  useEffect(() => {
    const ce = new CodeMirror(ref.current, {
      value,
      mode,
      lineNumbers: true,
      theme: "darcula",
      tabSize: 2,
      readOnly,
    });
    editor.current = ce;
    return () => {
      // TODO: destroy better
      editor.current.display.wrapper.remove();
    };
  }, [editor, mode, value, readOnly]);
  return <div className="ce" {...{ ref }}></div>;
});

function CodeEditorWindow({ code: value, setCode }) {
  const editor = useRef();
  const [show, setShow] = useState(false);
  const { subscribe } = useContext(TreeContext);
  const [saved, setSaved] = useState(false);
  const saveCode = () => {
    if (!show) return;
    const code = editor.current.getValue();
    setCode(code);
    setSaved(true);
    setTimeout(() => setSaved(false), 500);
  };
  useEffect(() => {
    return subscribe(rootNamespace, "SHOW_EDITOR", () => setShow(true));
  }, [subscribe]);
  if (!show) return null;
  const Checkbox = () => (
    <>
      <i className="fa fa-check" />
      &nbsp;
    </>
  );
  return (
    <div className="cew">
      <div className="cew-t">
        <span>Editor</span>
        <button onClick={() => setShow(false)}>
          <span></span>
        </button>
      </div>
      <div className="cew-b">
        <CodeEditor ref={editor} {...{ value }} />
      </div>
      <div className="cew-f">
        <button onClick={saveCode}>{saved && <Checkbox />}Save</button>
      </div>
    </div>
  );
}

function ElementCodeEditor() {
  const [code, setCode] = useAttribute("code");
  return (
    <CodeEditorWindow code={code || sampleCode.onClick} {...{ setCode }} />
  );
}

function DocumentCodeEditor() {
  const { tree, updateTree } = useContext(TreeContext);
  if (!tree) return null;
  const { onLoad } = tree;
  const setCode = (onLoad) => updateTree("onLoad", onLoad);
  return (
    <CodeEditorWindow code={onLoad || sampleCode.onLoad} {...{ setCode }} />
  );
}

function Editor() {
  const { selection } = useContext(TreeContext);
  return selection ? <ElementCodeEditor /> : <DocumentCodeEditor />;
}

export default Editor;
